import androidx.compose.runtime.Composable
import kotlinx.browser.window

// Copies the invite text to the clipboard (with a Web Share sheet when the browser supports it).
@Composable
actual fun rememberInviteSharer(): (text: String) -> Unit = { text ->
    val nav = window.navigator.asDynamic()
    if (nav.share != null) {
        val data = js("{}")
        data.text = text
        nav.share(data)
    } else {
        nav.clipboard?.writeText(text)
    }
    Unit
}
